export const doctorKanbanColumns = {
  ARRIVED: {
    id: "ARRIVED",
    title: "Arrived",
  },
  IN_PROGRESS: {
    id: "IN_PROGRESS",
    title: "In Progress",
  },
  WAITING_FOR_XRAY: {
    id: "WAITING_FOR_XRAY",
    title: "Waiting For XRAY",
  },
  IN_XRAY: {
    id: "IN_XRAY",
    title: "In XRAY",
  },
  PAID: {
    id: "PAID",
    title: "Paid",
  },
};

export const doctorColumnOrder = [
  "ARRIVED",
  "IN_PROGRESS",
  "WAITING_FOR_XRAY",
  "IN_XRAY",
  "PAID",
];
